import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import React from 'react';

import s from './FormHeader.module.scss';

const FormHeader = ({
  title,
  subTitleColor = 'text.secondary',
  subTitle,
  BoxProps
}: {
  title?: string;
  subTitle?: string;
  subTitleColor?: string;
  BoxProps?: BoxProps;
}) => {
  return (
    <Box className={s.FormHeader} mb={2} {...BoxProps}>
      {title && <Typography variant="h1">{title}</Typography>}
      {subTitle && (
        <Typography variant="caption" mt={2} color={subTitleColor}>
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

export default observer(FormHeader);
